import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { toast } from 'react-toastify';

const GoogleLoginButton = ({ onSuccess, buttonText = 'Sign in with Google' }) => {
    const handleSuccess = (response) => {
        // Google Identity Services returns credential while normal OAuth returns access_token
        if (response.credential) {
          onSuccess({ credential: response.credential });
        } else if (response.access_token) {
          onSuccess({ access_token: response.access_token });
        }
      };

  const handleError = () => {
    toast.error('Google login failed. Please try again.');
  };

  return (
    <div className="d-flex justify-content-center mb-4">
      <GoogleLogin
        onSuccess={handleSuccess}
        onError={handleError}
        useOneTap
        text="signin_with"
        shape="rectangular"
        theme="filled_blue"
        logo_alignment="center"
      />
    </div>
  );
};

export default GoogleLoginButton;